module.exports = __webpack_public_path__ + "static/media/Small car.36f812ff.svg";